<template>
    <div class="mylistwrap" v-if="isload" @click="moreshow()">
        <div v-if="($common.basic.isarrayexist(infolist))" class="mylist">
            <dl class="avg listheader" v-if="!issmall">
                <dd>{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('datebegin')}}</dd>
                <dd>{{$common.dicword('dateend')}}</dd>
                <dd v-if="navsub==1">{{$common.dicword('learnprogress')}}</dd>
                <dd v-else-if="navsub==3">{{$common.dicword('regcourse')}}</dd>
                <dd v-else-if="navsub==2">{{$common.dicword('learnprogress')}}</dd>

                <dd v-if="navsub>=101 && c_options.tk!=3">{{$common.dicword('infoclass')}}</dd>
                <dd v-if="(navsub>=101|| isviewstu)&& c_options.tk!=3">{{$common.dicword('stat')}}</dd>
                <dd v-if="navsub>=101">{{$common.dicword('learner')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="(item,index) in infolist" :key="item.id">
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span>
                        <router-link class="overparent" :to="'/course/'+item.courseid" :title="$common.langinfo(item.x_course.title,item.x_course.title_en)"><ffoverdot :title="item.x_course.title" :title_en="item.x_course.title_en" :needtitle="true"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('datebegin',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.datebegin)}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('dateend',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.dateend)}}
                    </dd>

                    <dd v-if="navsub==1||navsub==2" class="progress">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learnprogress',true)}}&nbsp;
                        </span>
                        <span class="box"><span class="past" :style="{width:item.x_course.x_perc+'%'}"></span></span>
                        <span>{{item.x_course.x_perc}}%</span>
                    </dd>
                    <dd v-else-if="navsub==3">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('regcourse',true)}}&nbsp;
                        </span>
                        <span v-if="item.x_issign">{{$common.dicword('reged')}}</span>
                        <a v-else class="listbtn" href="#" @click="signschedule(item.id)">{{$common.dicword('reg')}}</a>
                    </dd>
                    <dd v-if="navsub>=101 && c_options.tk!=3" class="ztwrap">

                        <template v-if="issmall">
                            <span class="smalltitle">
                                {{$common.dicword('infoclass',true)}} &nbsp;
                            </span>
                            <span>
                                <span v-for="(item2,index2) in item.x_groups" :key="index2">
                                    {{$common.langinfo(item2.title,item2.title_en)}}
                                </span>

                            </span>
                        </template>
                        <template v-else>

                            <span :class="[item.x_groupshow?'ztshow':'zt']" @mouseover="item.x_groupshow=item.x_groups.length>1" @mouseout="item.x_groupshow=false">

                                <span v-for="(item2,index2) in item.x_groups" :key="index2">
                                    {{$common.langinfo(item2.title,item2.title_en)}}
                                    <i v-if="!item.x_groupshow" :class="[(item.x_groups.length>1 && index2==0)?'iconfont icon-shiyuanjiaosanjiao':'iconfont']" @click.stop.prevent="moreshow(index)"></i>
                                </span>
                            </span>
                        </template>
                    </dd>
                    <dd v-if="(navsub>=101|| isviewstu)&& c_options.tk!=3">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('stat',true)}}&nbsp;
                        </span>
                        {{$common.langinfo(item.x_stat.title,item.x_stat.title_en)}}
                    </dd>
                    <dd v-if="navsub>=101">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span><fflearner :options="{'schid':item.id}"></fflearner>
                    </dd>
                </dl>
            </div>

            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>
        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"
    export default {
        name: 'Cschedule',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tea_my_schedule'
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {

                    if (this.isstu || this.stuid > 0) {
                        this.$common.each(res.infodatacourse, (item) => {
                            item.x_perc = 0;
                            let pro = this.$common.basic.fffind(res.infodatalearn || [], 'courseid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_perc = Math.round(pro.perc);
                            }
                        });
                    }


                    this.$common.each(res.infodata, item => {
                        item.x_issign = false;

                        item.x_course = this.$common.basic.fffind(res.infodatacourse, 'id', item.courseid);
                        item.x_stat = this.$common.basic.fffind(res.infodatastat, 'kv', item.stat);

                        item.x_groups = [];
                        item.x_groupshow = false;

                        if (this.isteaview && item.groupids) {
                            let groupids = item.groupids.split(',');
                            let _groups = [];
                            this.$common.each(groupids, (item) => {
                                let cgroup = this.$common.basic.fffind(this.grouplist, 'id', item);
                                if (this.$common.basic.isobjexist(cgroup)) {
                                    _groups.push(cgroup);
                                }
                            });
                            item.x_groups = _groups;


                        }

                    });
                    this.infolist = res.infodata;
                    this.res = res;

                    this.isload = true;
                });
            },
            signschedule: function (id) {
                this.$common.confirm(this.$common.dicword("tipschedulereg"), () => {
                    let jsondata = {
                        'postdata': { 'act': 'tea_my_schedule_sign', 'id': id, 'msg': '' }
                    };
                    this.$common.post(jsondata, () => {
                        this.$nextTick(function () {
                            let csch = this.$common.basic.fffind(this.infolist, 'id', id);
                            csch.x_issign = true;
                        });

                    });
                });
            },
            moreshow: function (v) {
                this.$common.each(this.infolist, (item, index) => {
                    if (v == index) {
                        item.x_groupshow = !item.x_groupshow;
                    }
                    else {
                        item.x_groupshow = false;
                    }
                });
            }
        }
    }

</script>
